import React, { useState, useEffect } from "react";
import {
    Box,
    FormControl,
    FormHelperText,
    InputLabel,
    Select,
} from "@material-ui/core";
import MultiSelectCheckbox from "./multiSelectCheckbox";

const MultiControlledMetadataSelect = ({
    label,
    id,
    value,
    options,
    onChange,
    hasError,
    isRequired,
}) => {
    const [localValue, setLocalValue] = useState(
        Array.isArray(value) ? value : [],
    );
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        setLocalValue(value || []);
    }, [value]);

    const handleChange = (newValue) => {
        setLocalValue(newValue);
        onChange({ target: { name: id, value: newValue } });
    };

    const toggleCheckbox = (option) => {
        let newValue;
        if (option.id === "all") {
            newValue = [{ appliesToAll: true }];
        } else {
            const isSelected = localValue.some(
                (item) => item._id === option._id,
            );
            newValue = isSelected
                ? localValue.filter((item) => item._id !== option._id)
                : [...localValue.filter((item) => !item.appliesToAll), option];
        }
        handleChange(newValue);
    };

    const isOptionChecked = (option) => {
        if (option.id === "all") {
            return localValue.some(({ appliesToAll }) => appliesToAll);
        }
        return localValue.some((item) => item._id === option._id);
    };

    const renderValue = (selected) => {
        if (!Array.isArray(selected) || selected.length === 0) {
            return "";
        }
        if (
            selected.some(({ appliesToAll }) => appliesToAll) ||
            selected.length === options.length
        ) {
            return "All";
        }
        return selected
            .map((item) => options.find((opt) => opt._id === item._id)?.name)
            .join(", ");
    };

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
                <InputLabel>{label} <span style={{color: "red"}}>{isRequired ? "*" : ""}</span></InputLabel>
                <Select
                    name={id}
                    multiple
                    value={localValue}
                    label={label}
                    renderValue={renderValue}
                    onOpen={(event) => setAnchorEl(event.target)}
                    onClose={() => setAnchorEl(null)}
                    open={Boolean(anchorEl)}
                    required={isRequired}
                >
                    <MultiSelectCheckbox
                        values={[{ id: "all", name: "All" }, ...options]}
                        toggleCheckbox={toggleCheckbox}
                        isOptionChecked={isOptionChecked}
                        anchorEl={anchorEl}
                        handleClose={() => setAnchorEl(null)}
                    />
                </Select>
                {hasError && (
                    <FormHelperText style={{ color: "red" }}>
                        This is required!
                    </FormHelperText>
                )}
            </FormControl>
        </Box>
    );
};

export default MultiControlledMetadataSelect;
